import styled from "styled-components";
import { palette } from "styled-theme";

const TransferHouseVisitsWrapper = styled.div`
  .modalHeader {
    display: flex;
    justify-content: space-between;
    background-color: ${palette("surfaceColor", 0)};
    padding: 10px;
    align-items: center;
    .save {
      margin: 0 10px;
    }
    border-bottom: 1px solid ${palette("border", 0)};
    h5.ant-typography {
      margin: 0 10px;
    }
  }
`;

export default TransferHouseVisitsWrapper;
